import { WordPressSources } from "../consts";
import { extractFromPTagsFromRawText, fetchMultiplePages } from "../utils";
export async function fetchMajorResearchItems() {
    const apiResponse = await fetchMultiplePages(WordPressSources.majorProjects);
    let parsedData = [];
    // Convert each array item into the major projects type
    apiResponse.forEach(item => {
        parsedData.push(parseRawMajorResearchJSON(item));
    });
    return parsedData;
}
function parseRawMajorResearchJSON(json) {
    let parsed = {
        id: json.title.rendered.replace(/\s/g, '-').replace(/\./g, '').toLowerCase(),
        name: json.title.rendered,
        impact: extractFromPTagsFromRawText(json.content.rendered, "h2", "impact"),
        backgroundImageSrc: getMajorResearchImageSources(json.content.rendered, true).background,
        projectImageSrc: getMajorResearchImageSources(json.content.rendered, true).project,
        collaborators: getMajorResearchImageSources(json.content.rendered, false),
        summary: extractFromPTagsFromRawText(json.content.rendered, "h2", "summary"),
        team: [],
        publications: []
    };
    // Team Members Array
    const replaced = parseMajorProjectList(json.content.rendered, "h2", "ul", "team");
    if (Array.isArray(replaced)) {
        replaced[0].target.childNodes.forEach(e => {
            parsed.team.push(e.innerHTML);
        });
    }
    // Publications Array
    if (parseMajorProjectList(json.content.rendered, "h3", "ul")) {
        parseMajorProjectList(json.content.rendered, "h3", "ul").forEach(e => {
            let obj = {
                category: e.header.innerHTML,
                items: []
            };
            e.target.querySelectorAll("li").forEach(li => obj.items.push(li.innerHTML));
            parsed.publications.push(obj);
        });
    }
    return parsed;
}
// Cleanly extracts src attribute from <img> tag in WordPress content
function getMajorResearchImageSources(rawString, coverImages) {
    const regex = /<img[^>]+src=([^>]+)>/g;
    const imgString = rawString.match(regex);
    if (imgString == null)
        return;
    if (!Array.isArray(imgString))
        return;
    if (imgString.length < 1)
        return;
    let elem = document.createElement('div');
    if (coverImages) {
        // Project Image
        elem.innerHTML = imgString[0];
        elem.innerHTML = elem.innerHTML + imgString[1];
        return {
            background: elem.querySelectorAll('img')[0].src,
            project: (elem.querySelectorAll('img').length > 1) ? elem.querySelectorAll('img')[1].src : null
        };
    }
    else {
        // Collaborator Images
        let imgSrcArray = [];
        imgString.forEach((match, i) => {
            // Ignore first and second images (project image and background image)
            if (i == 0 || i == 1)
                return;
            elem.innerHTML = elem.innerHTML + match;
        });
        elem.querySelectorAll("img").forEach(e => {
            imgSrcArray.push(e.src);
        });
        return imgSrcArray;
    }
}
// Get an array of 'targetTag' elements based on tag's innerHTML match
function parseMajorProjectList(rawString, tag, targetTag, string) {
    const regex = new RegExp(`<${tag}(.*?)>(.*?)<\/${tag}>(((\\\\[a-z])*?)|((\\s)*?))(<${targetTag}(.*?)>)(.*?)(<\/${targetTag}>)`, 'gim');
    const matchedDetails = rawString.match(regex);
    if (matchedDetails == null)
        return;
    const parsedList = [];
    matchedDetails.forEach(element => {
        const elem = document.createElement('div');
        elem.innerHTML = element;
        if (string) {
            if (!elem.querySelector(tag).textContent.toLowerCase().includes(string.toLowerCase()))
                return;
        }
        parsedList.push({
            header: elem.querySelector("h3"),
            target: elem.querySelector(targetTag)
        });
    });
    return parsedList;
}
